export default __webpack_public_path__ + "static/media/Panasonic BT-4LH310P.5b51808b.png";